import React, { useEffect, useState } from "react";
import { changeEmpresa } from "../../../helpers/storage/changeEmpresa.js";
import { useNavigate } from 'react-router-dom';
import { iconSidebar } from "../../../helpers/iconSidebar.js";
import { greenColor, blueColor_two } from "../../../const/colors/colorsTheme.js";
import useThemeStylingByHEX from "../../../hooks/useThemeStylingByHEX.js";
import Tooltip from '@mui/material/Tooltip';

// BtnCompany: Componente que renderiza el botón para cambiar de empresas dentro del chat.

const BtnCompany = ({ onChangeIcons }) => {
    const navigate = useNavigate();
    const [empresas, setEmpresas] = useState([]); //Estado para actualizar y mapear las empresas del usuario.
    const [active, setActive] = useState({}); //Estado para setear el estado de los botones activos de empresas.
    const [idEmpresaSelected, setIdEmpresaSelected] = useState(1); //Estado para actualizar el id de la empresa seleccioanda.
    const [colorByIdEmpresa, setColorByIdEmpresa] = useState(blueColor_two);

    const handleChangeEmpresa = async (idEmpresa) => {//Función para cambiar los datos de la empresa.
        await changeEmpresa(idEmpresa); //Actualizar los sus permisos de rutas según empresa.

        setIdEmpresaSelected(idEmpresa); //Actualizar el id de la empresa seleccionada.
        let iconsList = iconSidebar(); //Extraer el objeto con los íconos que debe tener el sidebar.
        //Llamar a la función callback que actualiza la lista de íconos dentro de Inicio.jsx.
        onChangeIcons(iconsList);
        navigate('Chats', { replace: true }); //Redireccionar a "Chats".
        if (idEmpresa === 1) setColorByIdEmpresa(blueColor_two);
        if (idEmpresa === 2) setColorByIdEmpresa(greenColor);
    };

    useThemeStylingByHEX(colorByIdEmpresa); //Invocar al custom hook para actualizar la paleta de colores.

    useEffect(() => { //Extraer el array con las empresas que pertenece el usuario logeado.
        const getEmpresas = async () => {
            // Obtener el objeto userData con los datos del usuario del localStorage.
            let userData = await JSON.parse(localStorage.getItem('userData'));
            let empresa = userData.Empresas.map(empresa => empresa.IdEmpresa)
            handleChangeEmpresa(empresa[0]); //Seleccionar el id de la primera empresa del array.
            await setEmpresas(userData.Empresas);

            //Setear el botón activo de la empresa, para colorear como en el sidebar.
            await setActive({ ...active, empresa: false })
        }
        getEmpresas();
    }, []);


    return (
        <>
            <div className="content-navigation__buttons">
                {empresas.map((empresa) => (
                    <a key={empresa.IdEmpresa}>
                        <Tooltip title="Empresa" >
                            <button onClick={() => handleChangeEmpresa(empresa.IdEmpresa)}
                                className={`btn-navigation__empresa ${empresa.IdEmpresa === idEmpresaSelected ? "active" : ""}`}>
                                {empresa.Empresa}
                            </button>
                        </Tooltip>
                    </a>
                ))}
            </div>
        </>

    )
};

export default BtnCompany;